module.exports = __webpack_public_path__ + "img/klient.33f99b8d.svg";